// HR-v3 (R16): pure Label-Maps als testbare Helper (aus Pages ausgelagert)

export const PAYOUT_LABELS: Record<string, string> = {
  paid_out: 'Auszahlung',
  lesson_account: 'Lektionenkonto (IPB)',
}

// Direktorkonfig v2 (Q1): 'Privat' — vereinheitlicht mit ReviewModal,
// types/director.ts und den Backend-Mails (vorher 'Persönlich' nur hier).
export const ABSENCE_LABELS: Record<string, string> = {
  illness: 'Krankheit',
  training: 'Fortbildung',
  business_trip: 'Dienstreise',
  vacation: 'Urlaub',
  personal: 'Privat',
  other: 'Andere',
}

export const TX_TYPE_LABELS: Record<string, string> = {
  credit: 'Gutschrift',
  debit: 'Abbuchung',
  period_close: 'Periodenabschluss',
  manual: 'Manuell',
}

export function payoutLabel(kind: string | null | undefined): string {
  if (!kind) return '—'
  return PAYOUT_LABELS[kind] ?? kind
}

export function absenceLabel(kind: string | null | undefined): string {
  if (!kind) return '—'
  return ABSENCE_LABELS[kind] ?? kind
}

/**
 * Direktorkonfig v2 (D10): Label mit Snapshot-Priorität —
 * 1. Snapshot-Label des Requests (Name zum Einreichzeitpunkt),
 * 2. aktuelles Label aus der Arten-Liste der Schule,
 * 3. statische Map (offline-robust), 4. roher Key.
 * v3/F8: Util für Consumer mit verfügbarer currentLabels-Map (z.B. aus
 * useAbsenceTypes); Komponenten ohne Map nutzen die äquivalente Inline-
 * Kette `snapshot || map[key] || key`.
 */
export function absenceTypeLabel(
  snapshot: string | null | undefined,
  key: string | null | undefined,
  currentLabels?: Record<string, string>,
): string {
  if (snapshot) return snapshot
  if (!key) return '—'
  if (currentLabels?.[key]) return currentLabels[key]
  return ABSENCE_LABELS[key] ?? key
}

/** «−2.25 Lekt.» / «+5.5 Lekt.» / «—» für NULL/undefined */
export function lessonsLabel(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—'
  return `${value > 0 ? '+' : ''}${value.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Lekt.`
}

export const PERIOD_TYPE_LABELS: Record<string, string> = {
  school_year: 'Schuljahr',
  semester: 'Semester',
  custom: 'Frei',
}

export function periodTypeLabel(kind: string | null | undefined): string {
  if (!kind) return '—'
  return PERIOD_TYPE_LABELS[kind] ?? kind.replace(/_/g, ' ')
}

/** ISO-Datum (YYYY-MM-DD oder DateTime) als de-CH, ohne UTC-Tagesverschiebung. */
export function formatHrDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso)
  if (m) {
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    return d.toLocaleDateString('de-CH')
  }
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString('de-CH')
}

/** Erkennt «Modul nicht aktiv»-403 aus einem API-Fehler (R11) */
export function isModuleInactiveError(e: unknown): boolean {
  const detail = (e as { response?: { status?: number; data?: { detail?: string } } })?.response?.data?.detail
    ?? (e as { detail?: string })?.detail
    ?? (e as { message?: string })?.message
  return typeof detail === 'string' && detail.includes('nicht aktiv')
}
